import { gql } from 'urql';

export const CharacterDetails = gql`
  fragment CharacterDetails on Character {
    id
    name
    buildEarned
    buildUsed
    body
    mind
    resolve
    infection
    currentBody
    currentMind
    currentResolve
    currentLife
    lifeCapacity
    lifeGain
    lifeLoss
    latestLifecycleGainsThisYear
    faithId
    faithLevel
    loreIds
    skills {
      id
      characterSkillId
      level
      positions
    }
    fractures {
      id
      name
      createdAt
      removedAt
    }
    characterFellowships {
      id
      rank
      removedAt
      fellowship {
        id
        kind
        name
        maxRank
      }
    }
    strainId
    lineageId
    variant
    status
    staffNotes
    playerNotes
    createdAt
    version
  }
`;
